// Market (HioBuy) categories for the pages — a thin view over the marketplace
// taxonomy, src/lib/marketTaxonomy.js (main category → subcategory → product
// type). Kept as its own module so pages read labels without knowing the
// taxonomy's internals.
//
// ISOLATED from src/lib/categoryTree.js: the shared tree stays the legacy
// catalog's, requests' and the supplier classifier's (classify-supplier-product
// carries a copy, guarded by classifierTaxonomy.test.js) and nothing here reads
// or changes it. Earlier market codes (which were that tree's leaves plus six
// market-only categories) are moved by marketTaxonomy.js LEGACY_MAP.

import { TAXONOMY, NODES, nodeLabel } from './marketTaxonomy.js';

// How many products a category holds (and how many categories there are) is
// hidden everywhere for now — owner, 2026-10-21. Since 2026-10-22 (owner) this
// also hides the listing total: «N منتج» beside the heading of all products, a
// category or a search, and the count on the phone filter panel's button. The
// categories themselves and their links stay. Also hidden since 2026-10-22: the
// count beside each filter option (material, colour, …), which shows how many
// products have it. Set to true to show the numbers again. A supplier's product
// count is not hidden.
export const SHOW_CATEGORY_COUNTS = false;

/** Main categories: [{ code, ar, en, desc_ar, desc_en, regulated, groups: [{ code, ar, en, types: […] }] }]. */
export const MARKET_CATEGORY_TREE = TAXONOMY;
export const MARKET_CATEGORY_BY_CODE = Object.fromEntries(TAXONOMY.map((c) => [c.code, c]));

const atLevel = (code, level) => (NODES[code]?.level === level ? NODES[code] : null);
export const marketNode = (code) => NODES[code] || null;
export const isMarketCategory = (code) => !!atLevel(code, 1);
export const isMarketSubcategory = (code, main) => !!atLevel(code, 2) && (!main || NODES[code].main === main);
export const isMarketProductType = (code, sub) => !!atLevel(code, 3) && (!sub || NODES[code].sub === sub);

export const marketCategoryLabel = (code, lang) => (atLevel(code, 1) ? nodeLabel(code, lang) : '');
/** Label of a subcategory or product type. */
export const marketLeafLabel = (code, lang) => (NODES[code] && NODES[code].level > 1 ? nodeLabel(code, lang) : '');
